import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { products, featuredSections } from '../mockData';
import { Button } from '../components/ui/button';
import { useLanguage } from '../contexts/LanguageContext';
import { getTranslation } from '../translations';

const Home = () => {
  const { language } = useLanguage();
  const t = (key) => getTranslation(language, key);
  
  return (
    <div className="min-h-screen">
      <div className="pt-20">
        <section className="relative h-[600px] overflow-hidden group">
          <div className="absolute inset-0">
            <img
              src="https://customer-assets.emergentagent.com/job_multi-lingua-3/artifacts/ql7zbvyi_operasyonel%20kiralama%20resim.png"
              alt={t('homeRentalTitle')}
              className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
              style={{ objectPosition: 'center 80%' }}
            />
            <div className="absolute inset-0 bg-gradient-to-r from-black/60 to-transparent"></div>
          </div>
          <div className="relative h-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center">
            <div className="max-w-xl text-white">
              <h2 className="text-5xl font-bold mb-4 animate-in slide-in-from-left duration-700">
                {t('homeRentalTitle')}
              </h2>
              <p className="text-xl mb-8 animate-in slide-in-from-left duration-700 delay-100">
                {t('homeRentalDesc')}
              </p>
              <Link to="/rental">
                <Button className="bg-sky-500 hover:bg-sky-600 text-white group animate-in slide-in-from-left duration-700 delay-200">
                  {t('learnMore')}
                  <ArrowRight className="ml-2 w-4 h-4 transition-transform group-hover:translate-x-1" />
                </Button>
              </Link>
            </div>
          </div>
        </section>

        <section className="relative h-[600px] overflow-hidden group">
          <div className="absolute inset-0">
            <img
              src="https://customer-assets.emergentagent.com/job_elerien-tr/artifacts/xn5ghotx_e60%20havaliman%C4%B1.jpg"
              alt={t('homeProfessionalTitle')}
              className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
              style={{ objectPosition: 'center 70%' }}
            />
            <div className="absolute inset-0 bg-gradient-to-r from-black/60 to-transparent"></div>
          </div>
          <div className="relative h-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center">
            <div className="max-w-xl text-white">
              <h2 className="text-5xl font-bold mb-4 animate-in slide-in-from-left duration-700">
                {t('homeProfessionalTitle')}
              </h2>
              <p className="text-xl mb-8 animate-in slide-in-from-left duration-700 delay-100">
                {t('homeProfessionalDesc')}
              </p>
              <Link to="/professional">
                <Button className="bg-sky-500 hover:bg-sky-600 text-white group animate-in slide-in-from-left duration-700 delay-200">
                  {t('learnMore')}
                  <ArrowRight className="ml-2 w-4 h-4 transition-transform group-hover:translate-x-1" />
                </Button>
              </Link>
            </div>
          </div>
        </section>
      </div>

      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {featuredSections.map((section, index) => (
              <Link
                key={section.id}
                to={section.link}
                className="group relative h-80 overflow-hidden rounded-lg shadow-lg transition-all duration-300 hover:shadow-2xl animate-in fade-in slide-in-from-bottom duration-700"
                style={{ animationDelay: `${index * 100}ms` }}
              >
                <div className="absolute inset-0">
                  {section.video ? (
                    <video
                      src={section.video}
                      autoPlay
                      loop
                      muted
                      playsInline
                      className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                    />
                  ) : (
                    <img
                      src={section.image}
                      alt={t(section.titleKey)}
                      className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                    />
                  )}
                  <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/30 to-transparent"></div>
                </div>
                <div className="relative h-full flex flex-col justify-end p-6 text-white">
                  {section.badge && (
                    <div className="inline-block mb-3 transition-transform duration-300 group-hover:scale-105">
                      <span className="bg-yellow-500 text-gray-900 px-3 py-1 rounded-full text-xs font-semibold">
                        {section.badge}
                      </span>
                    </div>
                  )}
                  <h3 className="text-2xl font-bold mb-2 transition-transform duration-300 group-hover:translate-x-2">
                    {t(section.titleKey)}
                  </h3>
                  <p className="text-gray-200 transition-transform duration-300 group-hover:translate-x-2">
                    {t(section.descriptionKey)}
                  </p>
                  <div className="mt-4 flex items-center text-sky-400 font-semibold transition-transform duration-300 group-hover:translate-x-2">
                    <span>{t('readMore')}</span>
                    <ArrowRight className="ml-2 w-4 h-4 transition-transform group-hover:translate-x-2" />
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;
